var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoKeyGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-key-green",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.3,
    height: 22.3,
    viewBox: "0 0 22.3 22.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "key_1_",
    "data-name": "key (1)",
    d: "M175.739,170.536A1.159,1.159,0,1,0,176.9,171.7,1.159,1.159,0,0,0,175.739,170.536Zm5.8.2-.009,3.662a3.122,3.122,0,0,1-1.94,2.886c-.191.079-.392.153-.6.222v6.31a1.159,1.159,0,0,1-.347.827l-2.065,2.029a1.16,1.16,0,0,1-1.62.005l-2.051-1.992a1.159,1.159,0,0,1-.352-.832v-6.374c-.233-.078-.432-.152-.591-.213a3.07,3.07,0,0,1-1.96-2.908v-3.616a3.125,3.125,0,0,1,1.832-2.851,9.819,9.819,0,0,1,3.9-.887,10.07,10.07,0,0,1,3.941.874,3.109,3.109,0,0,1,1.867,2.858Zm-2.319-.005a.791.791,0,0,0-.475-.727,7.714,7.714,0,0,0-3.008-.68,7.489,7.489,0,0,0-2.956.686.791.791,0,0,0-.46.736v3.616a.76.76,0,0,0,.473.741,9.607,9.607,0,0,0,1.194.382,1.159,1.159,0,0,1,.884,1.126v6.753l.887.861.91-.894v-6.7a1.159,1.159,0,0,1,.889-1.128,7.7,7.7,0,0,0,1.148-.359.81.81,0,0,0,.5-.747Zm0,0",
    transform: "translate(12.021 -238.295) rotate(45)",
    fill: "#1c787e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoKeyGreen);
export default __webpack_public_path__ + "static/media/ico-key-green.e84b56372bed69b96e6616a3894cef19.svg";
export { ForwardRef as ReactComponent };